import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getAttendance = async (queryParamas) => {
  const response = await axios.get(
    `${base_url}attendancereport/allstaterole/vcvt?${queryParamas}`,
    config
  );
  console.log(response.data, "get r");

  return response.data;
};

const getAWeeklyttendance = async (id) => {
  const response = await axios.get(
    `${base_url}attendancereport/weekly/${id}`,
    config
  );

  return response.data;
};
const getSchoolVisits = async (params) => {
  const response = await axios.get(`${base_url}schoolVisist/school`, config);

  return response.data;
};
const postAssignSchool = async (data) => {
  try {
    const response = await axios.post(
      `${base_url}schoolVisist/create`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getSchoolVisitCount = async (params) => {
  try {
    const response = await axios.get(`${base_url}schoolVisist`, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const attendanceService = {
  getAttendance,
  getAWeeklyttendance,
  getSchoolVisits,
  postAssignSchool,
  getSchoolVisitCount,
};

export default attendanceService;

// import axios from "axios";
// import { config } from "../../utils/axiosconfig";
// import { base_url } from "../../utils/baseUrl";

// const getAttendance = async (queryParams) => {
//   const response = await axios.get(
//     `${base_url}attendancereport/allstaterole/vcvt?${queryParams}`,
//     config()
//   );
//   console.log(response.data, "get r");
//   return response.data;
// };

// const getAWeeklyttendance = async (id) => {
//   const response = await axios.get(
//     `${base_url}attendancereport/weekly/${id}`,
//     config()
//   );
//   return response.data;
// };

// const getSchoolVisits = async (params) => {
//   try {
//     const response = await axios.get(`${base_url}schoolVisist/school`, config); // ✅ Fix here
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };
// const getSchoolVisitCount = async (params) => {
//   try {
//     const response = await axios.get(`${base_url}schoolVisist`, config);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// const postAssignSchool = async (data) => {
//   try {
//     const response = await axios.post(
//       `${base_url}schoolVisist/create`,
//       data,
//       config
//     );
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// const attendanceService = {
//   getAttendance,
//   getAWeeklyttendance,
//   getSchoolVisits,
//   postAssignSchool,
//   getSchoolVisitCount,
// };

// export default attendanceService;
